import { useConfig } from '@exam-center/configuration';
import { Alert, AlertTitle, Flex, List, ListItem, Text } from '@shared/components';

import { type ImportExamineeAnswersErrorDetails } from '../../types';

import { mapErrorsMessageWithTargetRows } from './utils';

interface ImportExamineeAnswersErrorAlertProps {
  errors: Record<string, ImportExamineeAnswersErrorDetails[]>;
}

export default function ImportExamineeAnswersErrorAlert(
  props: Readonly<ImportExamineeAnswersErrorAlertProps>,
) {
  const { errors } = props;

  const {
    examEvent: {
      paperAnswer: { spreadsheetSheetName },
    },
  } = useConfig();

  const errorRows = mapErrorsMessageWithTargetRows(errors, {
    worksheetSheetName: spreadsheetSheetName,
  });

  return (
    <Alert
      severity='error'
      sx={{
        alignItems: 'flex-start',
        '& .MuiAlert-message': { overflow: 'unset' },
        gap: (theme) => theme.spacing(1),
      }}
    >
      <AlertTitle variant='body1Semibold' sx={{ m: 0 }}>
        {errorRows.length > 0
          ? 'ไม่สามารถนำเข้าไฟล์ได้'
          : 'นำเข้าไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง'}
      </AlertTitle>
      {errorRows.length > 0 ? (
        <Flex sx={{ flexDirection: 'column' }}>
          <Text variant='body2'>กรุณาตรวจสอบและแก้ไขข้อมูลต่อไปนี้ก่อนนำเข้าใหม่:</Text>
          <List sx={{ listStyle: 'disc', p: (theme) => theme.spacing(0, 0, 0, 6) }}>
            {errorRows.map(({ message, rows }, index) => (
              <ListItem
                key={`${message}-${index}`}
                sx={(theme) => ({
                  display: 'list-item',
                  p: theme.spacing(0),
                  ...theme.typography.body2,
                })}
              >
                {rows.length ? `แถวที่ ${rows.join(', ')}: ${message}` : `${message}`}
              </ListItem>
            ))}
          </List>
        </Flex>
      ) : null}
    </Alert>
  );
}
